import React from 'react';
import { AF_STATUS } from '../consts';
function ArrythReportData({ record, avgData }) {
    var _a, _b;
    avgData = JSON.parse(avgData || '{}');
    const { af: afStatus } = avgData;
    console.log('afStatus', afStatus);
    const getCirclePIColor = () => {
        if (!+(avgData === null || avgData === void 0 ? void 0 : avgData.pi))
            return '';
        if (+(avgData === null || avgData === void 0 ? void 0 : avgData.pi) < 0.3)
            return 'red';
        if (+(avgData === null || avgData === void 0 ? void 0 : avgData.pi) < 0.4)
            return 'orange';
        if (+(avgData === null || avgData === void 0 ? void 0 : avgData.pi) < 0.6)
            return 'yellow';
        if (+(avgData === null || avgData === void 0 ? void 0 : avgData.pi) >= 0.6)
            return 'green';
    };
    const getAfStatusText = () => {
        let text = 'Measurement failed to finish properly';
        if (afStatus === AF_STATUS.afDetected)
            text = 'AF detected';
        if (afStatus === AF_STATUS.noAf)
            text = 'AF not detected';
        return text;
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'info-bottom-section' },
            React.createElement("div", { className: `cardio-hide size-2 status-af ${afStatus ? 'red-team' : 'green-team'}` }, getAfStatusText()),
            React.createElement("div", { className: 'size-1 info-bottom' },
                React.createElement("hr", null),
                React.createElement("div", { className: "info-bottom-massure text-black" },
                    React.createElement("span", { className: 'pi-content' },
                        React.createElement("span", { className: `coloring-circle cardio-color-${getCirclePIColor()}` }),
                        "PI \u2013 ",
                        (avgData === null || avgData === void 0 ? void 0 : avgData.pi) > 0 ? (_a = avgData === null || avgData === void 0 ? void 0 : avgData.pi) === null || _a === void 0 ? void 0 : _a.toFixed(2) : '00',
                        " %"),
                    React.createElement("span", null,
                        "PWV \u2013 ",
                        (avgData === null || avgData === void 0 ? void 0 : avgData.pwv) > 0 ? (_b = avgData === null || avgData === void 0 ? void 0 : avgData.pwv) === null || _b === void 0 ? void 0 : _b.toFixed(2) : '00',
                        " meter/sec"))))));
}
export default ArrythReportData;
